import React from "react";
import { Box } from "@mui/material";
import LoadingMessage from "./LoadingMessage";
import GlassMediaLoader from "./GlassMediaLoader";
import ImageMessage from "./ImageMessage";
import VideoMessage from "./VideoMessage";
import ContentMessage from "./ContentMessage";
import ErrorMessage from "./ErrorMessage";
import { mobileNavMediaQuery } from "../../../layout/layoutMetrics";

export default function BotMessage({
  msg,
  index,
  copiedMessageId,
  setCopiedMessageId,
  handleDownload,
  onViewGeneratedVideo,
}) {
  const showHydrationLoader =
    !msg.loading && msg.loadingMedia && (msg.isImage || msg.isVideo);

  return (
    <Box
      sx={{
        alignSelf: "flex-start",
        maxWidth: "70%",
        [`@media ${mobileNavMediaQuery}`]: {
          maxWidth: "92%",
          minWidth: 0,
          wordBreak: "break-word",
          overflowWrap: "anywhere",
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          borderRadius: 4,
          overflow: "hidden",
          border: "1px solid rgba(255,255,255,0.1)",
        }}
      >
        {msg.loading && (
          <LoadingMessage
            mediaType={msg.mediaType}
            videoReady={msg.videoReady}
            onViewVideo={() => onViewGeneratedVideo?.(msg.id)}
          />
        )}

        {showHydrationLoader && (
          <GlassMediaLoader
            mediaType={msg.isVideo ? "video" : "image"}
            mode="loading"
          />
        )}

        {!msg.loading && !msg.loadingMedia && msg.isImage && (
          <ImageMessage msg={msg} handleDownload={handleDownload} />
        )}

        {!msg.loading && !msg.loadingMedia && msg.isVideo && (
          <VideoMessage msg={msg} handleDownload={handleDownload} />
        )}

        {!msg.loading && msg.isContent && (
          <ContentMessage
            msg={msg}
            index={index}
            copiedMessageId={copiedMessageId}
            setCopiedMessageId={setCopiedMessageId}
          />
        )}

        {!msg.loading &&
          !msg.loadingMedia &&
          !msg.isImage &&
          !msg.isVideo &&
          !msg.isContent && (
          <ErrorMessage msg={msg} />
        )}
      </Box>
    </Box>
  );
}